import {TweenMax, Power2} from 'gsap';
import 'select2';
import {GTM} from "../utils/gtml";

interface NativeMailSentEvent extends Event {
  detail: { inputs: { name: string; value: string }[] };
}

export class ContactForm {

  public static element: HTMLElement;
  public static $element: JQuery<HTMLElement>;
  public static $jobContact: JQuery<HTMLElement>;
  public static $form: JQuery<HTMLElement>;
  public static tradString: any;
  public static onPageJob: boolean;

  public static init() {

    ContactForm.$element = $('.Contact-form');
    ContactForm.element = ContactForm.$element.get(0);
    ContactForm.$form = ContactForm.$element.find('#formulaire_contact');
    ContactForm.$jobContact = $('.Jobs-Contact');
    ContactForm.tradString = ContactForm.$element.data('contactstring');

    ContactForm.onPageJob = ContactForm.$jobContact.length > 0;

    // init seulement sur les pages avec un form de contact
    // + cas particuler sur page jobs, voir plus bas
    if ($('#page-contact').length || ContactForm.onPageJob || $('.Landing-page-contact').length) {
      ContactForm.events();
    }

    if ($('#page-contact').length || $('.Landing-page-contact').length) {
      ContactForm.setupGTMEvents();
    }
  }

  public static canExecute = true;

  public static events() {

    // ajout dynamique du champ disable
    $("select#chez").prepend('<option disabled selected value="">' + ContactForm.tradString.str_chezvouscheznous + '</option>');

    if (!ContactForm.onPageJob) {

      $('.form-1 select').select2({
        //allowClear: true,
        dropdownAutoWidth: true,
        width: 'auto',
        theme: "ktb",
        minimumResultsForSearch: -1,
        dropdownParent: $('.form-1'),
        //dropdownParent : $('.modal-ktb-dropdown')
      });
    }

    $('.form-2 select').select2({
      //allowClear: true,
      dropdownAutoWidth: true,
      width: '100%',
      theme: "ktb-small",
      minimumResultsForSearch: -1,
      //dropdownParent : $('.modal-ktb-dropdown')
    });
    $("#file").on('change', function () {
      let file = $(this).val();
      $('#fichier-contact .input-like').html(ContactForm.baseName(file));
    });

    $('#message').on('keyup', function () {
      $(this).attr('rows', ContactForm.getLine($(this)) + 1);
    });

    ContactForm.$form.find("input, textarea, select").on('keyup blur change', function () {
      ContactForm.checkForm(this);
    });

    ContactForm.$form.find('#je-veux').on('change', function () {
      ContactForm.changeScene(this);
    });

    // On déclenche à la main le changement de scene pour initialiser le formulaire
    ContactForm.$form.find('#je-veux').trigger('change');

    // Ajout du background sur les élément btn-contact et Bouton
    ContactForm.$form.find('.btn-contact').append('<div class="btn-background"></div>');
    // ContactForm.$form.find('.btn-ktb').append('<div class="btn-background"></div>');

    // Animation du background
    // SEULEMENT SUR LA PAGE CONTACT !
    if ($('#page-contact').length) {
      console.log('page-contact');
      ContactForm.animateBackground();
    }

    // Quand on clique sur le bouton d'envoi du formulaire
    ContactForm.$form.find('[type=submit]').on('click', function (e) {
      e.preventDefault();
      ContactForm.$form.find('[type=submit]').prop('disabled', true);
      ContactForm.submitEvent();
    });

    // force le mode "nous rejoinre"
    if (ContactForm.onPageJob) {
      ContactForm.doChangeScene(2);
    }
  }

  public static checkForm(el: any) {

    // Inititalisation

    let $this = $(el);
    let required = $this.attr("required") === 'required';
    if ($this.hasClass('wpcf7-validates-as-required')) {
      required = true;
    }

    let value = $this.val();
    let label = $this.parents('label');
    let type = $this[0].type;
    let notice = "";

    // Si le champ appartient à la scene, on ne vérifie pas

    if (label.data('scenario')) {
      var scene = ContactForm.$form.find('#je-veux option:selected').data('scene');
      var scenario = label.data('scenario');

      if (!ContactForm.isInScene(scenario, scene)) return true;
    }

    // Vérification

    if (required) {
      if (type != "select-one" && value.toString().length == 0) {
        ContactForm.fieldAppearance(label, false, ContactForm.tradString.str_champ_obli);
        return false;
      } else if (type == "select-one" && typeof value != 'string') {
        ContactForm.fieldAppearance(label, false, ContactForm.tradString.str_champ_obli);
        return false;
      } else {
        ContactForm.fieldAppearance(label, true);
      }
    }

    if (type == 'email' && !ContactForm.validateEmail(value.toString())) {
      ContactForm.fieldAppearance(label, false, ContactForm.tradString.str_verif_email);
      return false;
    } else {
      ContactForm.fieldAppearance(label, true);
    }

    return true;

  }

  public static isInScene(scenario: any, scene: any) {
    let scenarioArray = new Array();
    scene = scene.toString();

    if (scenario.toString().length > 0) {
      scenarioArray = scenario.toString().split('|');
    } else {
      scenario[0] = scenario.toString();
    }

    if ($.inArray(scene, scenarioArray) > -1) {
      return true

    } else {
      return false;
    }
  }

  // Gère l'apparence des champs vérifiés
  public static fieldAppearance(label: any, valid: any, notice?: any) {
    let $notice = label.find('.notice');
    $notice.text(notice);

    if (valid == true) {
      label.addClass('form-valide');
      label.removeClass('form-invalide');
      TweenMax.to($notice, 0.2, {autoAlpha: 0});
      label.data('valid', true);
    } else if (valid == false) {
      label.removeClass('form-valide');
      label.addClass('form-invalide');
      TweenMax.to($notice, 0.2, {autoAlpha: 1});
      label.data('valid', false);
    } else {
      label.removeClass('form-valide');
      label.removeClass('form-invalide');
      TweenMax.to($notice, 0.2, {autoAlpha: 0});
      label.removeData('valid');
    }
  }

  public static validateEmail(email: string) {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  public static changeScene(el: any) {
    let $this = $(el);
    let value = $this.val();
    let scene = $this.find('option:selected').data('scene');

    ContactForm.doChangeScene(scene);
  }

  public static doChangeScene(scene: number) {

    ContactForm.$form.find('label[data-scenario]').each(function (index, value) {

      var label = $(value);
      var scenario = label.data('scenario');

      if (ContactForm.isInScene(scenario, scene)) {
        label.show();
        label.find('input, textarea').attr('required', 'true');
      } else {
        label.hide();

        ContactForm.fieldAppearance(label, "reset", "");
        label.find('input, textarea').val('');
        label.find('input, textarea').removeAttr('required');
      }
    });

    // force le reset du obligatoire sur l'input file
    $("input#file").removeAttr('required');

  }

  // Animation du background
  public static animateBackground() {
    let bkgContact = $('.background-contact .bkg-contact-top-left');
    let bkgNez = $('.background-contact .bkg-nez');
    let bkgHommeBarbu = $('.background-contact .bkg-homme-barbu');

    // Animation
    TweenMax.to(bkgContact, 0.7, {autoAlpha: 1, x: "0%", delay: 1, ease: Power2.easeOut});
    TweenMax.to(bkgNez, 0.7, {autoAlpha: 1, x: "0%", delay: 1.5, ease: Power2.easeOut});
    TweenMax.to(bkgHommeBarbu, 0.7, {autoAlpha: 1, x: "0%", delay: 2, ease: Power2.easeOut});
  }

  public static submitEvent() {

    // Eviter d'envoyer plusieurs fois le formulaire
    setTimeout(function () {
      ContactForm.$form.find('[type=submit]').prop('disabled', false);
    }, 1000);

    // Evenements suite au clic
    let formValid = true;

    ContactForm.$form.find('input, textarea, select').each(function (index, value) {
      if (!ContactForm.checkForm(this)) {
        formValid = false;
      }
    });

    if (formValid && ContactForm.canExecute === true) {
      ContactForm.canExecute = false;

      let formActif = parseInt($("select#je-veux option:selected").attr('data-scene'));

      if (formActif == 0 || formActif == 1) {
        $("#yourrecipient").val('defaut');
      }
      if (formActif == 2) {
        $("#yourrecipient").val('job');
      }

      // utilisé pour transferer le form actif vers contact form car le vrai choix est hors contact form
      $("#formactif").val($("select#je-veux option:selected").val());
      ContactForm.$element.find(".wpcf7-response-output").remove();

      // force le stat sur job sur la page job car le select est masqué
      if (ContactForm.onPageJob) {
        $("#yourrecipient").val('job');
        $("#formactif").val(2);
      }

      // le bind sur l'event contact form est desactive pour l'usage du tracking qui remplace contact form et donc on a pas de retour de confirm de la prise en compte
      // on part du principe que c'est ok donc, le traitement normamement en retour du post du form en AJAX est affiché direct.

      ContactForm.$element.find(".wpcf7").on('wpcf7mailfailed', function () {
        console.debug("wpcf7 error send custom event 2");
      });

      ContactForm.$element.find(".wpcf7").on('wpcf7mailsent', function () {

        let lang = document.documentElement.lang;
        lang = lang.substring(0, 2);

        let homeUrl = $('body').attr('data-home-url');
        let contactForm = new FormData($(this).find('form').get(0) as HTMLFormElement);
        let contactData = {
          firstname: contactForm.get("prenom"),
          lastname: contactForm.get("nom"),
          email: contactForm.get("email"),
          form_name: "contact",
          form_origin: window.location.hostname,
          phone: contactForm.get("telephone"),
          form_subject: (contactForm.get("je-veux").slice(0, 1) as string).toUpperCase() + contactForm.get("je-veux").slice(1) + (contactForm.get("chez") ? " - " + contactForm.get("chez") : ""),
          form_message: contactForm.get("projet") ? contactForm.get("projet") : contactForm.get("message"),
          form_language: lang
        };

        $.ajax({
          url: homeUrl + "/wp-content/themes/ktb-v2/src/modules/loyalty-webmecanik/webmecanikFunctions.php",
          data: contactData,
          method: "POST",
        });

        ContactForm.$element.find(".wpcf7").hide();
        ContactForm.$element.find("label[data-scenario]").removeClass('form-valide');

        // customisation du msg de confirmation d'envoi
        $(".form-conform-ok span.custom-msg").hide();
        $(".form-conform-ok span.form-rep-" + formActif).show();

        // bind de l'action de fermeture de la confirmation
        $(".form-conform-ok .close-forminfo").unbind().click(function () {
          $(".form-conform-ok").hide();
          ContactForm.$element.find(".wpcf7").show();
        });

        location.hash = "#contactAnchor";

        $(".form-conform-ok").show();

      });

      ContactForm.$form.find('[type=submit]').prop('disabled', false);

      // jQuery trigger('submit') & submit() doesn't trigger Contact Form events
      ContactForm.$form.get(0).dispatchEvent(new Event('submit', {bubbles: true}));

      setTimeout(function () {
        ContactForm.canExecute = true;
      }, 10000);

    } // endif

  }

  // FONCTIONS OUTILS

  public static baseName(path: any) {
    return path.replace(/\\/g, '/').replace(/.*\//, '');
  }

  public static getLine(element: any) {
    let t = $(element).val().toString();
    return (t.split("\n").length);
  }

  public static setupGTMEvents() {
    const contactFormElement = ContactForm.$element.find('.wpcf7').get(0);
    contactFormElement.addEventListener('wpcf7mailsent', (e: NativeMailSentEvent) => {
      const inputs = e.detail.inputs;
      const emailInput = inputs.find((i) => i.name === 'email');
      const phoneInput = inputs.find((i) => i.name === 'telephone');
      GTM.add({'event': 'contact', 'email': emailInput.value, 'phone_number': phoneInput.value});
    })
  }
}
